module.exports = __webpack_public_path__ + "static/media/PF.84d7c703.svg";